import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";
import { encodeData } from "~/utils/utils";

export const useProjectCostSummary = (projectId, queryData = {}, config = {}) => {
  const query = encodeData(queryData); //from, to, group_by

  return useQuery({
    ...config,
    queryKey: ["project-cost-summary", projectId, query],
    queryFn: ({ signal }) => {
      let url = `${Angie.api_url}/projects/${projectId}/budget`;

      if (query) {
        url += `?${query}`;
      }

      return fetch({
        url,
        signal,
      });
    },
  });
};

export const useTaskCostSummary = (projectId, taskId, config = {}) => {
  return useQuery({
    ...config,
    queryKey: ["task-cost-summary", projectId, taskId],
    queryFn: ({ signal }) => {
      return fetch({
        url: `${Angie.api_url}/projects/${projectId}/tasks/${taskId}/budget`,
        signal,
      });
    },
  });
};
